import React, { Component } from "react";
import InputBox from "components/InputBox";
import { TextFieldValidator } from "components/InputBox/TextFieldValidator";

export default class ChartTagUpperLimitRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getValue() || ""
    };
  }

  changeHandler = newValue => {
    const processedValue = newValue === "" ? null : parseFloat(newValue);
    this.setState({ value: newValue });

    const { rowIndex, data } = this.props.node;
    this.props.node.setData({ ...data, Yupper: processedValue, isEdited: true });
    this.props.context.updateChartView("Yupper");
  };

  getValue = () => {
    return this.props.node.data.Yupper !== undefined && this.props.node.data.Yupper !== null ? this.props.node.data.Yupper.toString() : "";
  };

  clearInput = () => {
    this.changeHandler("");
  };

  render() {
    return (
      <InputBox
        value={this.state.value}
        onChange={this.changeHandler}
        validator={TextFieldValidator.NUMBER_WITH_DECIMALS_AND_NEGATIVE}
        placeholder="Upper Limit"
        customClass="chart-limits"
        clearInput={this.clearInput}
        maxLength={15}
      />
    );
  }
}
